<template>
  <b-card>
    <h4
      v-if="errMessage"
      class="text-danger"
    >
      {{ errMessage }}
    </h4>
    <base-overlay :show="loading">
      <b-button
        v-if="$can('write', 'driver-devices')"
        variant="primary"
        @click="newDevice"
      >
        Add Device
      </b-button>
      <hr>
      <DeviceDetailsForm
        v-if="firstDevice"
        :data="firstDevice"
        :driver="driver"
        @submitted="fetchDetails"
        @device-blocked="fetchDetails"
      />
      <template v-if="!loading && data.length">
        <card-collapse title="View More Devices">
          <DeviceDetailsForm
            v-for="item in data"
            :key="item.id"
            :data="item"
            :driver="driver"
            @submitted="fetchDetails"
            @device-blocked="fetchDetails"
          />
        </card-collapse>
      </template>
    </base-overlay>
  </b-card>
</template>

<script>
import { BCard, BButton } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import DeviceDetailsForm from './DeviceDetailsForm.vue'
import CardCollapse from '@/UI/CardCollapse.vue'

export default {
  components: {
    BCard, BButton, DeviceDetailsForm, CardCollapse,
  },
  props: {
    driver: {
      type: Object,
      required: true,
    },
  },
  setup(props, ctx) {
    const loading = ref(false)
    const data = ref(null)
    const errMessage = ref(null)
    const showForm = ref(false)
    const firstDevice = ref()
    const fetchDetails = async () => {
      loading.value = true
      errMessage.value = null
      data.value = null
      try {
        data.value = await ctx.root.$store.dispatch('driverView/fetchDriverDevices', {
          id: props.driver.id,
        })
        // eslint-disable-next-line prefer-destructuring
        firstDevice.value = data.value.splice(0, 1)[0]
      } catch (error) {
        errMessage.value = error?.response?.data?.error?.message
      } finally {
        loading.value = false
      }
    }
    const newDevice = () => {
      data.value.unshift({
        device_id: null,
        device_type: 'ANDROID',
        supports_google: false,
        application_version: null,
        operating_system: null,
        status: 'PENDING',
        added_by: 'MANUAL',
        newDevice: true,
      })
    }
    fetchDetails()
    return {
      firstDevice,
      newDevice,
      fetchDetails,
      loading,
      data,
      errMessage,
      showForm,
    }
  },
}
</script>

<style>

</style>
